import {MenuItem,} from "~/native-ui/Menu";
import styled from "styled-components/native";
import { WithBaseStyles } from "../hoc";

export const DropdownOption = styled(WithBaseStyles(MenuItem, {
    baseStyle: {
        borderTopWidth: 1,
        borderTopColor: "gray.300",
        py: 2,
        
    }
}))`
    cursor: pointer;
`